import assertString from './util/assertString.js';

function ltrim(str,chars){assertString(str);var pattern=/^\s+/g;return str.replace(pattern,"")}

export { ltrim as default };
//# sourceMappingURL=ltrim.js.map
